export interface SearchSynonymGroupRequest {
  data: string
}

export function SearchSynonymGroupRequestToJSON(
  value: SearchSynonymGroupRequest
): any {
  return {
    data: value.data !== '' ? value.data : undefined
  }
}
